export enum InvoiceStatusEnum {
  TRANSMITTED = 'TRANSMITTED',
  VALIDATED = 'VALIDATED',
  REFUSED = 'REFUSED',
}
